import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { ApplicationLinkV3Data, ApplicationLinkV3Status } from '../common/types.tsx';
import { APPLINKS_V3_QUERY_URL } from '../common/constants.tsx';

export const fetchApplinks = (): Promise<ApplicationLinkV3Data[]> =>
	fetchJson(APPLINKS_V3_QUERY_URL);

export const fetchApplinkStatus = (id: string): Promise<ApplicationLinkV3Status> =>
	fetchJson(`/rest/applinks/3.0/status/${id}`);
